import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import ReadOnlyItem from "../../../components/forms/ReadOnlyItem";
import { getFullName } from "../../../components/util/helpers";
import { useIntl } from "react-intl";

import moment from "moment";

const PreviousVisit = (props) => {
  const { visit } = props;
  const intl = useIntl();
  const [name, setName] = useState("");
  useEffect(() => {
    if (visit.planned_employee) {
      let employeeName = getFullName(
        visit.planned_employee.surename,
        visit.planned_employee.first_name
      );
      if (visit.planned_employee.professional_role_id) {
        const role =
          visit.planned_employee.professional_role_id &&
          intl.formatMessage({
            id: `app.dataSelect.professional_role_id.${visit.planned_employee.professional_role_id}`,
            defaultMessage: ""
          });
        employeeName = employeeName.concat(", ", role);
      }
      setName(employeeName);
    }
  }, [intl, visit.planned_employee]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.house_visits.previous_visit" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={20} xl={18} xxl={18}>
            <ResponsiveItemsWrapper>
              <div style={{ display: "flex", flex: 1 }}>
                <div style={{ display: "flex", flex: 1 }}>
                  <ReadOnlyItem
                    content={moment(visit.date).format("DD/MM/YYYY")}
                    name="date"
                    category="house_visits"
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ display: "flex", flex: 1 }}>
                  <ReadOnlyItem
                    content={`${visit.duration_minutes} ${intl.formatMessage({
                      id: "app.forms.house_visits.minutes",
                    })}`}
                    name="duration_minutes"
                    category="house_visits"
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ display: "flex", flex: 1 }}>
                  <ReadOnlyItem
                    content={name}
                    name="planned_employee_id"
                    category="house_visits"
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ display: "flex", flex: 1 }}>
                  <ReadOnlyItem
                    content={
                      visit.care_giver_was_presented
                        ? intl.formatMessage({
                            id: "app.forms.yes",
                          })
                        : intl.formatMessage({
                            id: "app.forms.no",
                          })
                    }
                    name="care_giver_was_presented"
                    category="house_visits"
                  />
                </div>
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
};

export default PreviousVisit;
